import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import MiniCenteredFooter from "components/MiniCenteredFooter.js";
import { ReactComponent as DeveloperIcon } from "feather-icons/dist/icons/server.svg";
import { ReactComponent as WhatIcon } from "feather-icons/dist/icons/help-circle.svg";
import { ReactComponent as ManagementIcon } from "feather-icons/dist/icons/settings.svg";
import { ReactComponent as MapIcon } from "feather-icons/dist/icons/map.svg";
import { ReactComponent as RGAIcon } from "feather-icons/dist/icons/globe.svg";
import { ReactComponent as GAIcon } from "feather-icons/dist/icons/monitor.svg";
import { ReactComponent as FactionIcon } from "feather-icons/dist/icons/activity.svg";
import { ReactComponent as CommunityIcon } from "feather-icons/dist/icons/users.svg";
import { ReactComponent as DiscordIcon } from "images/discord-icon.svg";
import DiscordIconDev from "images/discord-icon-dev.png";
import DiscordIconComm from "images/discord-icon-comm.png";
import background from 'images/staff_background.jpg';


const Card = tw.div`-z-20 h-full flex! flex-col border rounded-tl-4xl rounded-br-5xl relative focus:outline-none`;
const TextInfo = tw.div`py-6 px-6 sm:px-10 sm:py-6`;
const TitleReviewContainer = tw.div`flex flex-col flex-row justify-between items-center`;
const Title = tw.h5`text-2xl sm:text-3xl font-bold pr-6`;
const RatingsInfo = styled.div`
  ${tw`flex items-center sm:ml-4 mt-2 sm:mt-0`}
  svg {
    ${tw`w-20 h-20 sm:w-24 sm:h-24`}
  }
`;
const SecondaryInfoContainer = tw.div`flex flex-col sm:flex-row mt-2 sm:mt-4`;
const IconWithText = tw.div`flex items-center mr-6 my-2 mt-3`;
const IconContainer = styled.div`
  svg {
    ${tw`w-6 h-6`}
  }
`;
const Text = tw.div`ml-2 text-sm font-semibold text-gray-800`;

const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-xl mx-auto`}
`;
const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/4 px-6 flex`}
`;
const InnerCard = styled.div`
  ${tw`flex flex-col mx-auto max-w-xs items-center px-6 py-8 border-2 border-dashed rounded-lg mt-6`}
  .imageContainer {
    ${tw`border-2 border-primary-500 text-center rounded-full p-6 flex-shrink-0 relative`}
    img {
      ${tw`w-8 h-8`}
    }
  }

  .textContainer {
    ${tw`text-center`}
  }

  .title {
    ${tw`font-bold text-xl leading-none`}
  }

  .subtitle {
    ${tw`mt-3 font-bold text-sm leading-none`}
  }

  .description {
    ${tw`mt-1 font-semibold text-sm leading-loose`}
  }
`;

const Container = styled.div`
  ${tw`relative -mx-8 -mt-8 bg-center bg-cover flex justify-center items-center`}
  background-image: url(${background});
`;
const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-primary-800 opacity-75`;
const HeroContainer = tw.div`z-20 relative px-6 sm:px-8 mx-auto h-full flex flex-col`;
const Content = tw.div`px-4  my-auto mx-auto`;
const Heading = styled.h1`
  ${tw`text-3xl text-center sm:text-4xl lg:text-5xl xl:text-6xl font-black text-gray-100 leading-snug -mt-24 mt-0`}
  span {
    ${tw`inline-block mt-2`}
  }
`;

const SlantedBackground = styled.span`
  ${tw`relative text-primary-600 px-4 -mx-4 py-2`}
  &::before {
    content: "";
    ${tw`absolute inset-0 bg-gray-100 transform -skew-x-12 -z-10`}
  }
`;
const Image = styled.img(props => [
  props.imageRounded && tw`rounded`,
  props.imageBorder && tw`border`,
  props.imageShadow && tw`shadow`
]);


export default () => {
  return (
    <AnimationRevealPage>
      <Container style={{ minHeight: "25rem" }}>
        <OpacityOverlay />
        <HeroContainer>
          <Content>
            <Heading>
              <SlantedBackground>Lo staff di Rewind</SlantedBackground>
            </Heading>
          </Content>
        </HeroContainer>
      </Container>
      <Card style={{ backgroundColor: "#fed330" }} tw="mt-10">
        <TextInfo>
          <TitleReviewContainer>
            <Title>Team Management</Title>
            <RatingsInfo tw="text-orange-500">
              <ManagementIcon />
            </RatingsInfo>
          </TitleReviewContainer>
          <SecondaryInfoContainer>
            <IconWithText>
              <IconContainer>
                <WhatIcon />
              </IconContainer>
              <Text>Il Team Management ha il compito di supervisionare la produttività dei gruppi di lavoro ed ha potere decisionale sul progetto.</Text>
            </IconWithText>
          </SecondaryInfoContainer>
          <ThreeColumnContainer>
            <Column>
              <InnerCard tw="border-orange-500">
                <span className="textContainer">
                  <span className="title" tw="text-orange-500">crossover</span>
                  <p className="description" tw="text-secondary-200">
                    Responsabile<br />Comunicazioni e Staff
                  </p>
                  <p className="subtitle" tw="text-orange-500"><DiscordIcon tw="inline w-5 h-5 mr-2" />crossover#7865</p>
                </span>
              </InnerCard>
            </Column>
            <Column>
              <InnerCard tw="border-orange-500">
                <span className="textContainer">
                  <span className="title" tw="text-orange-500">FedeFluork</span>
                  <p className="description" tw="text-secondary-200">
                    Head<br />Team Sviluppo
                  </p>
                  <p className="subtitle" tw="text-orange-500"><DiscordIcon tw="inline w-5 h-5 mr-2" />FedeFluork#3536</p>
                </span>
              </InnerCard>
            </Column>
          </ThreeColumnContainer>
        </TextInfo>
      </Card>

      <Card tw="mt-6 bg-primary-300">
        <TextInfo>
          <TitleReviewContainer>
            <Title tw="text-secondary-900">Team Sviluppo</Title>
            <RatingsInfo tw="text-primary-700">
              <DeveloperIcon />
            </RatingsInfo>
          </TitleReviewContainer>
          <SecondaryInfoContainer>
            <IconWithText>
              <IconContainer tw="text-secondary-800">
                <WhatIcon />
              </IconContainer>
              <Text tw="text-secondary-900">Il Team Sviluppo si occupa di aggiornamenti, correzioni di bug e migliorie delle piattaforme Rewind, come la gamemode, il sito web o il launcher.</Text>
            </IconWithText>
          </SecondaryInfoContainer>
          <ThreeColumnContainer>
            <Column>
              <InnerCard tw="border-primary-800">
                <span className="textContainer">
                  <span className="title" tw="text-primary-800">Tipix</span>
                  <p className="description" tw="text-gray-400">
                    Sviluppatore<br />Gamemode
                  </p>
                  <p className="subtitle" tw="text-primary-800"><Image tw="inline w-5 h-5 mr-2" src={DiscordIconDev} />Tipix(Tiziano)#1641</p>
                </span>
              </InnerCard>
            </Column>
            <Column>
              <InnerCard tw="border-primary-800">
                <span className="textContainer">
                  <span className="title" tw="text-primary-800">stock</span>
                  <p className="description" tw="text-gray-400">
                    Sviluppatore<br />Gamemode
                  </p>
                  <p className="subtitle" tw="text-primary-800"><Image tw="inline w-5 h-5 mr-2" src={DiscordIconDev} />stock#8014</p>
                </span>
              </InnerCard>
            </Column>
            <Column>
              <InnerCard tw="border-primary-800">
                <span className="textContainer">
                  <span className="title" tw="text-primary-800">CR412</span>
                  <p className="description" tw="text-gray-400">
                    Sviluppatore<br />Gamemode
                  </p>
                  <p className="subtitle" tw="text-primary-800"><Image tw="inline w-5 h-5 mr-2" src={DiscordIconDev} />CR412#5196</p>
                </span>
              </InnerCard>
            </Column>
          </ThreeColumnContainer>
        </TextInfo>
      </Card>

      <Card tw="mt-6 bg-blue-600">
        <TextInfo>
          <TitleReviewContainer>
            <Title>Team Community</Title>
            <RatingsInfo tw="text-blue-800">
              <CommunityIcon />
            </RatingsInfo>
          </TitleReviewContainer>
          <SecondaryInfoContainer>
            <IconWithText>
              <IconContainer>
                <WhatIcon />
              </IconContainer>
              <Text>Il Team Community svolge compiti di promozione delle piattaforme Rewind, a partire dalla realizzazione di grafiche/videoclip fino all'instaurazione di partnerships.</Text>
            </IconWithText>
          </SecondaryInfoContainer>
          <ThreeColumnContainer>
            <Column>
              <InnerCard tw="border-blue-900">
                <span className="textContainer">
                  <span className="title" tw="text-blue-900">Sergio</span>
                  <p className="description" tw="text-secondary-400">
                    Social Media<br />Manager
                  </p>
                  <p className="subtitle" tw="text-blue-900"><Image tw="inline w-5 h-5 mr-2" src={DiscordIconComm} />Sergio#6016</p>
                </span>
              </InnerCard>
            </Column>
            <Column>
              <InnerCard tw="border-blue-900">
                <span className="textContainer">
                  <span className="title" tw="text-blue-900">Francesco</span>
                  <p className="description" tw="text-secondary-400">
                    Multimedia Developer
                  </p>
                  <p className="subtitle" tw="text-blue-900"><Image tw="inline w-5 h-5 mr-2" src={DiscordIconComm} />Francesco#6562</p>
                </span>
              </InnerCard>
            </Column>
            <Column>
              <InnerCard tw="border-blue-900">
                <span className="textContainer">
                  <span className="title" tw="text-blue-900">CesareMakaveli</span>
                  <p className="description" tw="text-secondary-400">
                    Partnership
                  </p>
                  <p className="subtitle" tw="text-blue-900"><Image tw="inline w-5 h-5 mr-2" src={DiscordIconComm} />ɢʊɛʀʀǟ#7205</p>
                </span>
              </InnerCard>
            </Column>
            <Column>
              <InnerCard tw="border-blue-900">
                <span className="textContainer">
                  <span className="title" tw="text-blue-900">ottoschultz</span>
                  <p className="description" tw="text-secondary-400">
                    Partnership
                  </p>
                  <p className="subtitle" tw="text-blue-900"><Image tw="inline w-5 h-5 mr-2" src={DiscordIconComm} />ottoschultz#2777</p>
                </span>
              </InnerCard>
            </Column>
          </ThreeColumnContainer>
        </TextInfo>
      </Card>

      <Card tw="mt-6 bg-green-600">
        <TextInfo>
          <TitleReviewContainer>
            <Title>Team Fazioni</Title>
            <RatingsInfo tw="text-green-800">
              <FactionIcon />
            </RatingsInfo>
          </TitleReviewContainer>
          <SecondaryInfoContainer>
            <IconWithText>
              <IconContainer>
                <WhatIcon />
              </IconContainer>
              <Text>Il Team Fazioni gestisce le fazioni legali/illegali presenti in gioco e controlla la qualità complessiva delle scene e le competenze del capofazione.</Text>
            </IconWithText>
          </SecondaryInfoContainer>
          <ThreeColumnContainer>
            <Column>
              <InnerCard tw="border-green-900">
                <span className="textContainer">
                  <span className="title" tw="text-green-900">Brugola</span>
                  <p className="description" tw="text-secondary-300">
                    Fazioni Illegali
                  </p>
                  <p className="subtitle" tw="text-green-900"><DiscordIcon tw="inline w-5 h-5 mr-2" />Dr. Her Brugola#3549</p>
                </span>
              </InnerCard>
            </Column>
            <Column>
              <InnerCard tw="border-green-900">
                <span className="textContainer">
                  <span className="title" tw="text-green-900">Laroong</span>
                  <p className="description" tw="text-secondary-300">
                    Fazioni Illegali
                  </p>
                  <p className="subtitle" tw="text-green-900"><DiscordIcon tw="inline w-5 h-5 mr-2" />Laroong#1103</p>
                </span>
              </InnerCard>
            </Column>
            <Column>
              <InnerCard tw="border-green-900">
                <span className="textContainer">
                  <span className="title" tw="text-green-900">Storm</span>
                  <p className="description" tw="text-secondary-300">
                    Fazioni Legali
                  </p>
                  <p className="subtitle" tw="text-green-900"><DiscordIcon tw="inline w-5 h-5 mr-2" />Storm#3098</p>
                </span>
              </InnerCard>
            </Column>
            <Column>
              <InnerCard tw="border-green-900">
                <span className="textContainer">
                  <span className="title" tw="text-green-900">Brasco</span>
                  <p className="description" tw="text-secondary-300">
                    Fazioni Legali
                  </p>
                  <p className="subtitle" tw="text-green-900"><DiscordIcon tw="inline w-5 h-5 mr-2" />Daniel Brasco (Brasco)#6107</p>
                </span>
              </InnerCard>
            </Column>
          </ThreeColumnContainer>
        </TextInfo>
      </Card>

      <Card tw="mt-6 bg-red-600">
        <TextInfo>
          <TitleReviewContainer>
            <Title>Game Assistant</Title>
            <RatingsInfo tw="text-red-800">
              <GAIcon />
            </RatingsInfo>
          </TitleReviewContainer>
          <SecondaryInfoContainer>
            <IconWithText>
              <IconContainer>
                <WhatIcon />
              </IconContainer>
              <Text>I Game Assistant sono i moderatori di gioco, il loro compito è aiutare l'utenza e garantire il rispetto del regolamento Roleplay.</Text>
            </IconWithText>
          </SecondaryInfoContainer>
          <ThreeColumnContainer>
            <Column>
              <InnerCard tw="border-red-900">
                <span className="textContainer">
                  <span className="title" tw="text-red-900">512mas</span>
                  <p className="description" tw="text-secondary-400">
                    Game Assistant
                  </p>
                  <p className="subtitle" tw="text-red-900"><DiscordIcon tw="inline w-5 h-5 mr-2" />512mas#0512</p>
                </span>
              </InnerCard>
            </Column>
            <Column>
              <InnerCard tw="border-red-900">
                <span className="textContainer">
                  <span className="title" tw="text-red-900">Maryhanne.</span>
                  <p className="description" tw="text-secondary-400">
                    Game Assistant
                  </p>
                  <p className="subtitle" tw="text-red-900"><DiscordIcon tw="inline w-5 h-5 mr-2" />Maryhanne.#7828</p>
                </span>
              </InnerCard>
            </Column>
            <Column>
              <InnerCard tw="border-red-900">
                <span className="textContainer">
                  <span className="title" tw="text-red-900">tomronk</span>
                  <p className="description" tw="text-secondary-400">
                    Game Assistant
                  </p>
                  <p className="subtitle" tw="text-red-900"><DiscordIcon tw="inline w-5 h-5 mr-2" />tomronk#5605</p>
                </span>
              </InnerCard>
            </Column>
            <Column>
              <InnerCard tw="border-red-900">
                <span className="textContainer">
                  <span className="title" tw="text-red-900">LoGaN</span>
                  <p className="description" tw="text-secondary-400">
                    Game Assistant
                  </p>
                  <p className="subtitle" tw="text-red-900"><DiscordIcon tw="inline w-5 h-5 mr-2" />LoGaN#2436</p>
                </span>
              </InnerCard>
            </Column>
            <Column>
              <InnerCard tw="border-red-900">
                <span className="textContainer">
                  <span className="title" tw="text-red-900">Melo</span>
                  <p className="description" tw="text-secondary-400">
                    Game Assistant
                  </p>
                  <p className="subtitle" tw="text-red-900"><DiscordIcon tw="inline w-5 h-5 mr-2" />FourGamers#1816</p>
                </span>
              </InnerCard>
            </Column>
            <Column>
              <InnerCard tw="border-red-900">
                <span className="textContainer">
                  <span className="title" tw="text-red-900">Drake</span>
                  <p className="description" tw="text-secondary-400">
                    Game Assistant
                  </p>
                  <p className="subtitle" tw="text-red-900"><DiscordIcon tw="inline w-5 h-5 mr-2" />vecchio-serpente#5502</p>
                </span>
              </InnerCard>
            </Column>
            <Column>
              <InnerCard tw="border-red-900">
                <span className="textContainer">
                  <span className="title" tw="text-red-900">jacz</span>
                  <p className="description" tw="text-secondary-400">
                    Game Assistant
                  </p>
                  <p className="subtitle" tw="text-red-900"><DiscordIcon tw="inline w-5 h-5 mr-2" />jacz#0520</p>
                </span>
              </InnerCard>
            </Column>
          </ThreeColumnContainer>
        </TextInfo>
      </Card>

      <Card tw="mt-6 bg-teal-300 mb-20">
        <TextInfo>
          <TitleReviewContainer>
            <Title>Mapper</Title>
            <RatingsInfo tw="text-teal-600">
              <MapIcon />
            </RatingsInfo>
          </TitleReviewContainer>
          <SecondaryInfoContainer>
            <IconWithText>
              <IconContainer>
                <WhatIcon />
              </IconContainer>
              <Text>I nostri Mapper sviluppano l'ambiente di gioco di Rewind grazie alla creazione di map e modelli personalizzati.</Text>
            </IconWithText>
          </SecondaryInfoContainer>
          <ThreeColumnContainer>
            <Column>
              <InnerCard tw="border-teal-700">
                <span className="textContainer">
                  <span className="title" tw="text-teal-700">Luponiko</span>
                  <p className="description" tw="text-secondary-100">
                    3D Modeler
                  </p>
                  <p className="subtitle" tw="text-teal-700"><DiscordIcon tw="inline w-5 h-5 mr-2" />Luponiko#8593</p>
                </span>
              </InnerCard>
            </Column>
            <Column>
              <InnerCard tw="border-teal-700">
                <span className="textContainer">
                  <span className="title" tw="text-teal-700">jacz</span>
                  <p className="description" tw="text-secondary-100">
                    Mapper
                  </p>
                  <p className="subtitle" tw="text-teal-700"><DiscordIcon tw="inline w-5 h-5 mr-2" />jacz#0520</p>
                </span>
              </InnerCard>
            </Column>
            <Column>
              <InnerCard tw="border-teal-700">
                <span className="textContainer">
                  <span className="title" tw="text-teal-700">Drake</span>
                  <p className="description" tw="text-secondary-100">
                    Mapper
                  </p>
                  <p className="subtitle" tw="text-teal-700"><DiscordIcon tw="inline w-5 h-5 mr-2" />vecchio-serpente#5502</p>
                </span>
              </InnerCard>
            </Column>
          </ThreeColumnContainer>
        </TextInfo>
      </Card>
      <MiniCenteredFooter />
    </AnimationRevealPage>
  );
};
/*
      <Card tw="mt-6 bg-red-500">
        <TextInfo>
          <TitleReviewContainer>
            <Title>Game Master</Title>
            <RatingsInfo tw="text-red-700">
              <RGAIcon />
            </RatingsInfo>
          </TitleReviewContainer>
          <SecondaryInfoContainer>
            <IconWithText>
              <IconContainer>
                <WhatIcon />
              </IconContainer>
              <Text>Il Game Master si occupa di coordinare i Game Assistant e delle faccende più complesse in gioco.</Text>
            </IconWithText>
          </SecondaryInfoContainer>
          <ThreeColumnContainer>
            <Column>
              <InnerCard tw="border-red-800">
                <span className="textContainer">
                  <span className="title" tw="text-red-800">///</span>
                  <p className="description" tw="text-gray-700">
                    ///
                  </p>
                  <p className="subtitle" tw="text-red-800"><DiscordIcon tw="inline w-5 h-5 mr-2" />///</p>
                </span>
              </InnerCard>
            </Column>
          </ThreeColumnContainer>
        </TextInfo>
      </Card>
*/